Pixlee.module('Concerns', function(Concerns, App, Backbone, Marionette, $) {

	Concerns.SetSponserUrl = {
		setUrl: function(){
			if (!_.isFalsy(params.header_sponserImage_input)){
				header_sponserImage_input = params.header_sponserImage_input;
				App.displayOptions.set('header_sponserImage_input', header_sponserImage_input);
				headerView = _this.getHeaderView({
					model: App.currentAlbum
				});
				_this.show(headerView, {
					region: layout.widget_header_region
				});
			}
		}
	};
});
